var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMenuHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: -0.25,
    width: 29.5,
    height: 29.5,
    rx: 2.75,
    transform: "matrix(0 -1 -1 0 29.5 29.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: -0.25,
    width: 29.5,
    height: 29.5,
    rx: 2.75,
    transform: "matrix(0 -1 -1 0 29.5 29.5)",
    stroke: "#ACB1C6",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.4706C23 14.7202 22.9008 14.9596 22.7243 15.1361C22.5478 15.3126 22.3084 15.4118 22.0588 15.4118H7.94117C7.69156 15.4118 7.45217 15.3126 7.27566 15.1361C7.09916 14.9596 7 14.7202 7 14.4706C7 14.221 7.09916 13.9816 7.27566 13.8051C7.45217 13.6286 7.69156 13.5294 7.94117 13.5294L22.0588 13.5294C22.3084 13.5294 22.5478 13.6286 22.7243 13.8051C22.9008 13.9816 23 14.221 23 14.4706ZM23 7.88235C23 8.13197 22.9008 8.37136 22.7243 8.54787C22.5478 8.72437 22.3084 8.82353 22.0588 8.82353L7.94117 8.82353C7.69156 8.82353 7.45217 8.72437 7.27566 8.54787C7.09916 8.37136 7 8.13197 7 7.88235C7 7.63274 7.09916 7.39335 7.27566 7.21684C7.45217 7.04034 7.69156 6.94118 7.94117 6.94118L22.0588 6.94118C22.3084 6.94118 22.5478 7.04034 22.7243 7.21684C22.9008 7.39335 23 7.63274 23 7.88235ZM23 21.0588C23 21.3084 22.9008 21.5478 22.7243 21.7243C22.5478 21.9008 22.3084 22 22.0588 22H7.94117C7.69156 22 7.45217 21.9008 7.27566 21.7243C7.09916 21.5478 7 21.3084 7 21.0588C7 20.8092 7.09916 20.5698 7.27566 20.3933C7.45217 20.2168 7.69156 20.1176 7.94117 20.1176H22.0588C22.3084 20.1176 22.5478 20.2168 22.7243 20.3933C22.9008 20.5698 23 20.8092 23 21.0588Z",
    fill: "#00378C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMenuHide);
export default __webpack_public_path__ + "static/media/userMenuHide.ce68d03ad43e59c358881c8b875da56a.svg";
export { ForwardRef as ReactComponent };